import type React from "react";
import {
  Paper,
  Typography,
  Box,
  IconButton,
  type SxProps,
  type Theme,
} from "@mui/material";
import { motion } from "framer-motion";

interface InfoCardProps {
  title: string;
  icon?: React.ReactNode; // Left icon
  actionIcon?: React.ReactNode; // Right icon (new)
  onActionClick?: () => void; // Click handler
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const MotionPaper = motion(Paper);

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  icon,
  actionIcon,
  onActionClick,
  children,
  sx,
}) => {
  return (
    <MotionPaper
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 2,
        backgroundColor: "background.paper",
        mb: 2,
        ...sx,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <Box display="flex" alignItems="center">
          {icon && <Box mr={1}>{icon}</Box>}
          <Typography variant="h6" component="h2" fontWeight="medium">
            {title}
          </Typography>
        </Box>

        {actionIcon && (
          <IconButton onClick={onActionClick}>{actionIcon}</IconButton>
        )}
      </Box>

      {children}
    </MotionPaper>
  );
};

export default InfoCard;
